<template>
  <div v-if="shouldShow" class="mobile-bottom-nav-wrapper no-print">
    <div
      v-if="showSheet"
      class="mobile-bottom-nav__overlay"
      @click="closeSheet"
    >
      <div class="mobile-bottom-nav__sheet" dir="rtl" @click.stop>
        <div class="mobile-bottom-nav__sheet-header">
          <button type="button" class="mobile-bottom-nav__sheet-close" @click="closeSheet" aria-label="بستن">
            <i class="fas fa-times"></i>
          </button>
          <span class="mobile-bottom-nav__sheet-title">{{ sheetTitle }}</span>
        </div>
        <ul class="mobile-bottom-nav__sheet-list">
          <li
            v-for="sub in sheetItems"
            :key="sub.id || sub.label"
            :class="{
              'mobile-bottom-nav__sheet-item--header': sub.isHeader,
              'mobile-bottom-nav__sheet-item--link': !sub.isHeader,
              'mobile-bottom-nav__sheet-item--logout': sub.action === 'logout',
            }"
          >
            <div v-if="sub.isHeader" class="mobile-bottom-nav__sheet-group">
              <i v-if="sub.icon" :class="sub.icon" class="mobile-bottom-nav__sheet-group-icon" aria-hidden="true"></i>
              <span class="mobile-bottom-nav__sheet-group-text">{{ sub.label }}</span>
            </div>
            <button
              v-else
              type="button"
              class="mobile-bottom-nav__sheet-link"
              :class="{ 'mobile-bottom-nav__sheet-link--danger': sub.action === 'logout' }"
              @click="handleSheetItemClick(sub)"
            >
              <span
                v-if="sub.isSubMenu"
                class="mobile-bottom-nav__sheet-bullet"
                aria-hidden="true"
              ></span>
              <i v-else-if="sub.icon" :class="sub.icon" aria-hidden="true"></i>
              <span class="mobile-bottom-nav__sheet-link-text">{{ sub.label }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <nav class="mobile-bottom-nav" dir="rtl" role="navigation" aria-label="منوی پایین">
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="mobile-bottom-nav__item"
        :class="{
          'mobile-bottom-nav__item--active': isActive(item),
        }"
        @click="handleItemClick(item)"
      >
        <span class="mobile-bottom-nav__icon-wrap">
          <i :class="item.icon" aria-hidden="true"></i>
          <span v-if="item.badge > 0" class="mobile-bottom-nav__badge">{{ item.badge }}</span>
        </span>
        <span class="mobile-bottom-nav__label">{{ item.label }}</span>
      </button>
    </nav>
  </div>
</template>

<script>
import { isRouteExcluded, isMobileScreenWidth } from '../../utils/mobileBottomNav'

export default {
  name: 'MobileBottomNav',
  props: {
    variant: {
      type: String,
      default: 'netpa',
      validator: (v) => v === 'netpa',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSheet: false,
      sheetItems: [],
      sheetTitle: 'بیشتر',
      isMobileViewport: false,
    }
  },
  computed: {
    shouldShow() {
      return this.isMobileViewport && this.items.length > 0 && !isRouteExcluded(this.$route.name)
    },
  },
  watch: {
    shouldShow: {
      immediate: true,
      handler(visible) {
        this.updateBodyClass(visible)
      },
    },
  },
  mounted() {
    this.checkViewport()
    window.addEventListener('resize', this.checkViewport)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewport)
    this.updateBodyClass(false)
  },
  methods: {
    checkViewport() {
      this.isMobileViewport = isMobileScreenWidth()
    },
    updateBodyClass(visible) {
      if (visible) {
        document.documentElement.classList.add('has-mobile-bottom-nav')
        document.body.classList.add('has-mobile-bottom-nav')
      } else {
        document.documentElement.classList.remove('has-mobile-bottom-nav')
        document.body.classList.remove('has-mobile-bottom-nav')
      }
    },
    isActive(item) {
      if (item.action === 'more' || item.action === 'menu') {
        return this.showSheet
      }
      if (this.showSheet) {
        return false
      }
      if (!item.routeName) return false

      const routeName = this.$route.name

      if (item.id === 'home') {
        return routeName === 'Home'
      }

      if (item.id === 'loan') {
        return ['loan', 'loanFollowup', 'LoanRequest', 'LoanCardex', 'ListVamRequests'].includes(routeName)
      }

      if (item.id === 'accounts') {
        return ['Accounts', 'Funds'].includes(routeName)
      }

      if (item.id === 'pay') {
        if (routeName !== 'Deposit') return false
        if (!item.params) return true
        const routeTashilat = this.$route.params.IsTashilat
        const itemTashilat = item.params.IsTashilat
        if (routeTashilat !== undefined && String(routeTashilat) !== String(itemTashilat)) {
          return false
        }
        return true
      }

      return routeName === item.routeName
    },
    handleItemClick(item) {
      if (item.action === 'more' || item.action === 'menu') {
        const nextTitle = item.action === 'menu' ? 'منو' : 'بیشتر'
        if (this.showSheet && this.sheetTitle === nextTitle) {
          this.closeSheet()
          return
        }
        this.sheetTitle = nextTitle
        this.sheetItems = item.moreItems || []
        this.showSheet = true
        return
      }
      this.closeSheet()
      this.navigateToItem(item)
    },
    handleSheetItemClick(sub) {
      if (sub.action === 'logout') {
        this.logout()
        return
      }
      if (sub.action === 'gotoModirShobe') {
        this.gotoModirShobe()
        return
      }
      this.navigateToItem(sub)
      this.closeSheet()
    },
    navigateToItem(item) {
      if (item.forceLogin) {
        this.$session.set('ForceLoginpage', true)
      }
      if (item.routeName) {
        const to = { name: item.routeName }
        if (item.params) to.params = item.params
        if (item.query) to.query = item.query
        if (this.$route.name !== item.routeName || item.params) {
          // route یکسان با param متفاوت (مثل Deposit) از نظر vue-router تکراری است
          if (
            this.$route.name === item.routeName &&
            item.params &&
            item.params.IsTashilat !== undefined
          ) {
            if (String(this.$route.params.IsTashilat) === String(item.params.IsTashilat)) {
              return
            }
            to.query = Object.assign({}, to.query, { t: Date.now() })
          }
          this.$router.push(to).catch(() => {})
        }
      }
    },
    logout() {
      const DataAxios = {
        Method: 'Post',
        Action: 'Logout',
        ArryfildValue: {},
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostData(DataAxios).then(() => {
        this.$store.state.Netpa_Cart = []
        this.$router.push('/')
        this.$session.clear()
        sessionStorage.removeItem('vuex')
        this.$store.state.PanelRout = []
        this.$ResetTimer()
        this.closeSheet()
      })
    },
    gotoModirShobe() {
      this.$session.set('UserInfoNetPa', this.$session.get('UserInfoNetPaModirShobe'))
      this.$session.set('UserInfoNetPaModirShobe', null)
      this.closeSheet()
      if (this.$route.name != 'Home') {
        this.$router.push('/PishkhanNetPa/Home').then(() => window.location.reload())
      } else {
        window.location.reload()
      }
    },
    closeSheet() {
      this.showSheet = false
      this.sheetItems = []
    },
  },
}
</script>

<style scoped>
/* توکن‌های NetPa — همراستا با NetPaNav.vue / docs/NETPA_DESIGN_SYSTEM.md */
.mobile-bottom-nav-wrapper {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-text-menu: #596a7d;
  --bnp-icon-muted: #8091a3;
  --bnp-surface-page: #f5f7fb;
  --bnp-surface-accent: #edf7fb;
  --bnp-border-default: #e1e8ee;
  --bnp-border-subtle: #e8eef2;
  --bnp-radius-md: 14px;
  --bnp-radius-lg: 20px;
  --bnp-active-gradient: linear-gradient(
    100deg,
    rgba(5, 184, 200, 0.12),
    rgba(141, 88, 164, 0.1)
  );
  --bnp-motion-fast: 180ms;
  display: none;
}

@media (max-width: 767px) {
  .mobile-bottom-nav-wrapper {
    display: block;
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1040;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }

  /* ───── نوار پایین ───── */
  .mobile-bottom-nav {
    position: relative;
    right: auto;
    left: auto;
    bottom: auto;
    z-index: 2;
    -webkit-tap-highlight-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    height: calc(var(--mobile-bottom-nav-height, 60px) + env(safe-area-inset-bottom, 0px));
    padding: 6px 8px env(safe-area-inset-bottom, 0px);
    background: rgba(255, 255, 255, 0.96);
    border-top: 1px solid var(--bnp-border-default);
    box-shadow: 0 -5px 18px rgba(31, 42, 79, 0.08);
  }

  .mobile-bottom-nav__item {
    position: relative;
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    padding: 2px 0;
    border: none;
    background: transparent;
    color: var(--bnp-text-menu);
    cursor: pointer;
    min-width: 0;
    overflow: visible;
    outline: none;
    box-shadow: none;
    -webkit-tap-highlight-color: transparent;
    transition: color var(--bnp-motion-fast) ease;
  }

  .mobile-bottom-nav__item:focus,
  .mobile-bottom-nav__item:focus-visible,
  .mobile-bottom-nav__item:active {
    outline: none;
    box-shadow: none;
    border: none;
  }

  .mobile-bottom-nav__icon-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 46px;
    height: 30px;
    border-radius: 12px;
    font-size: 17px;
    line-height: 1;
    color: var(--bnp-icon-muted);
    background: transparent;
    overflow: visible;
    transition: background var(--bnp-motion-fast) ease,
      color var(--bnp-motion-fast) ease;
  }

  .mobile-bottom-nav__item:active .mobile-bottom-nav__icon-wrap {
    background: var(--bnp-surface-accent);
    color: var(--bnp-brand-blue);
  }

  /* آیتم فعال — گرادیان فیروزه‌ای/بنفش + نوار نشانگر مثل سایدبار */
  .mobile-bottom-nav__item--active {
    color: var(--bnp-brand-navy);
  }

  .mobile-bottom-nav__item--active .mobile-bottom-nav__icon-wrap {
    background: var(--bnp-active-gradient);
    color: var(--bnp-brand-navy);
  }

  .mobile-bottom-nav__item--active::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    width: 26px;
    height: 3px;
    transform: translateX(-50%);
    border-radius: 0 0 999px 999px;
    background: linear-gradient(90deg, var(--bnp-brand-cyan), var(--bnp-brand-purple));
    pointer-events: none;
  }

  .mobile-bottom-nav__label {
    width: 100%;
    max-width: 100%;
    padding: 0 2px;
    box-sizing: border-box;
    font-size: 11px !important;
    font-weight: 600;
    line-height: 1.25;
    color: inherit;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mobile-bottom-nav__item--active .mobile-bottom-nav__label {
    color: var(--bnp-brand-navy);
    font-weight: 700;
  }

  .mobile-bottom-nav__badge {
    position: absolute;
    top: -2px;
    right: 4px;
    left: auto;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    box-sizing: border-box;
    border-radius: 999px;
    background: #d9534f;
    border: 2px solid #fff;
    color: #fff;
    font-size: 9px !important;
    font-weight: 700;
    line-height: 12px;
    text-align: center;
  }

  /* ───── شیت بیشتر / منو ───── */
  .mobile-bottom-nav__overlay {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: calc(var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px));
    z-index: 1;
    background: rgba(41, 52, 95, 0.42);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: calc(16px + env(safe-area-inset-top, 0px)) 12px 0;
    box-sizing: border-box;
  }

  .mobile-bottom-nav__sheet {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: none;
    overflow-x: hidden;
    overflow-y: auto;
    background: var(--bnp-surface-page);
    border: 1px solid var(--bnp-border-default);
    border-bottom: 0;
    border-radius: var(--bnp-radius-lg) var(--bnp-radius-lg) 0 0;
    box-shadow: 0 -8px 28px rgba(41, 52, 95, 0.16);
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    text-align: right;
  }

  .mobile-bottom-nav__sheet-header {
    position: sticky;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    background: rgba(255, 255, 255, 0.96);
    border-bottom: 1px solid var(--bnp-border-default);
  }

  .mobile-bottom-nav__sheet-title {
    flex: 1;
    text-align: right;
    font-size: 15px !important;
    font-weight: 700;
    color: var(--bnp-brand-navy);
  }

  .mobile-bottom-nav__sheet-close {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 1px solid var(--bnp-border-default);
    border-radius: 12px;
    background: #fff;
    color: var(--bnp-brand-navy);
    font-size: 15px !important;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    transition: background var(--bnp-motion-fast) ease,
      border-color var(--bnp-motion-fast) ease;
  }

  .mobile-bottom-nav__sheet-close:active {
    background: var(--bnp-surface-accent);
    border-color: #bdcbd4;
  }

  .mobile-bottom-nav__sheet-close:focus,
  .mobile-bottom-nav__sheet-close:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .mobile-bottom-nav__sheet-list {
    list-style: none;
    margin: 0;
    padding: 10px 10px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* عنوان گروه (مثل ردیف منوی والد در سایدبار) */
  .mobile-bottom-nav__sheet-group {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 6px;
    padding: 10px 12px;
    font-size: 13px !important;
    font-weight: 700;
    color: var(--bnp-brand-navy);
    text-align: right;
    background: var(--bnp-surface-accent);
    border-radius: 12px;
  }

  .mobile-bottom-nav__sheet-item--header:first-child .mobile-bottom-nav__sheet-group {
    margin-top: 0;
  }

  .mobile-bottom-nav__sheet-group-icon {
    flex-shrink: 0;
    width: 22px;
    text-align: center;
    color: var(--bnp-brand-blue);
    font-size: 15px !important;
  }

  .mobile-bottom-nav__sheet-group-text {
    text-align: right;
    line-height: 1.5;
  }

  .mobile-bottom-nav__sheet-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    min-height: 44px;
    padding: 10px 12px;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: 12px;
    background: #fff;
    text-align: right;
    color: var(--bnp-text-menu);
    font-size: 13px !important;
    font-weight: 600;
    cursor: pointer;
    transition: background var(--bnp-motion-fast) ease,
      color var(--bnp-motion-fast) ease;
  }

  .mobile-bottom-nav__sheet-link-text {
    text-align: right;
    line-height: 1.5;
  }

  /* بولت زیرمنو — دایره توخالی مثل child_menu سایدبار */
  .mobile-bottom-nav__sheet-bullet {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 18px;
  }

  .mobile-bottom-nav__sheet-bullet::before {
    content: '';
    width: 6px;
    height: 6px;
    box-sizing: border-box;
    border-radius: 50%;
    background: transparent;
    border: 1.5px solid rgba(40, 125, 180, 0.45);
  }

  .mobile-bottom-nav__sheet-link i {
    flex-shrink: 0;
    width: 22px;
    text-align: center;
    color: var(--bnp-icon-muted);
    font-size: 15px !important;
  }

  .mobile-bottom-nav__sheet-link:focus,
  .mobile-bottom-nav__sheet-link:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .mobile-bottom-nav__sheet-link:active {
    background: var(--bnp-surface-accent);
    color: var(--bnp-brand-blue);
  }

  .mobile-bottom-nav__sheet-link:active i {
    color: var(--bnp-brand-blue);
  }

  .mobile-bottom-nav__sheet-link:active .mobile-bottom-nav__sheet-bullet::before {
    background: var(--bnp-brand-blue);
    border-color: var(--bnp-brand-blue);
  }

  .mobile-bottom-nav__sheet-item--logout {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--bnp-border-subtle);
  }

  .mobile-bottom-nav__sheet-link--danger {
    color: #b44f46;
    font-weight: 700;
  }

  .mobile-bottom-nav__sheet-link--danger i {
    color: inherit;
  }

  .mobile-bottom-nav__sheet-link--danger:active {
    background: #fcefed;
    color: #9a3d36;
  }
}
</style>

<style>
@media (max-width: 767px) {
  :root {
    --mobile-bottom-nav-height: 68px;
  }

  body.has-mobile-bottom-nav .right_col {
    padding-bottom: calc(var(--mobile-bottom-nav-height, 68px) + 8px + env(safe-area-inset-bottom, 0px)) !important;
  }

  body.has-mobile-bottom-nav .staticPage {
    padding-bottom: calc(var(--mobile-bottom-nav-height, 68px) + 16px + env(safe-area-inset-bottom, 0px)) !important;
  }

  body.has-mobile-bottom-nav .container-fluid {
    padding-bottom: calc(var(--mobile-bottom-nav-height, 68px) + 8px + env(safe-area-inset-bottom, 0px));
  }

  body.has-mobile-bottom-nav .right_col .container-fluid {
    padding-bottom: 0;
  }

  body.has-mobile-bottom-nav .footer {
    bottom: calc(var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px)) !important;
  }

  body.has-mobile-bottom-nav #goTop {
    bottom: calc(var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px)) !important;
  }
}
</style>
